import type { InjectionKey } from "vue";
import { TenantSettings } from "./utils/models";
import { ComputedRef } from "vue";

export const settingsInjectionKey = Symbol() as InjectionKey<ComputedRef<TenantSettings>>;
export const tenantInjectionKey = Symbol() as InjectionKey<string>;
export const connectedServiceInjectionKey = Symbol() as InjectionKey<string>;
export const demoModeInjectionKey = Symbol() as InjectionKey<boolean>;
